export const eventTypes = {
    CHANGE: 'change',
    CLICK: 'click',
    PAGESHOW: 'pageshow'
};

const hosts = {
    production: 'www.check24.de',
    staging: 'www.check24-test.de'
};

const financeOrigins = {
    production: 'https://finanzen.check24.de',
    staging: 'https://finanzen.check24-test.de',
    integration: 'https://finanzen.check24-int.de'
};

export function getFinanceEnvironment(hostname) {
    switch (hostname) {
        case hosts.production:
            return financeOrigins.production;
        case hosts.staging:
            return financeOrigins.staging;
        default:
            return financeOrigins.integration;
    }
}
